import { createStore, applyMiddleware } from "redux";
import logger from "redux-logger";
import { combineReducers } from "redux";

import { fileReducer } from "./fileReducer";
import { templateReducer } from "./templateReducer";
import { singleTemplateReducer } from "./singleTemplateReducer";
import { zipListReducer } from "./helpersReducer";

const reducer = combineReducers({
  file: fileReducer,
  templates: templateReducer,
  importedTemplate: singleTemplateReducer,
  zip: zipListReducer,
});

export default createStore(reducer, applyMiddleware(logger));
